<template>
  <form class="box" @submit.prevent="submitData()">
    <div class="field">
      <label class="label">Select Your Services</label>
      <div class="control">
        <select :class="{'input': true, 'is-danger': errors.has('selected_service')}" v-model="selected_service">
          <option value="">Select your service</option>
          <option v-for="(services_row, index) in services_list" :key="index" :value="services_row.id">{{services_row.title}}</option>
        </select>
      </div>
      <span class="help is-danger" v-show="errors.has('selected_service')" v-text="errors.first('selected_service')"></span>
    </div>
    <div class="field">
      <label class="label">Select Your Counter</label>
      <div class="control">
        <select  :class="{'input': true, 'is-danger': errors.has('selected_counter')}" v-model="selected_counter">
          <option value="">Select your counter</option>
          <option v-for="(counter_row, index) in counter_list" :key="index" :value="counter_row.id">{{counter_row.title}}</option>
        </select>
      </div>
      <span class="help is-danger" v-show="errors.has('selected_counter')" v-text="errors.first('selected_counter')"></span>
    </div>
    <div class="field" v-for="(edc_bank_row, index_edc_bank) in edc_bank_list" :key="index_edc_bank">
      <label class="label" v-text="'Your ' + edc_bank_row.title + ' EDC Number (Type new EDC Number or choose from existing EDC Number)'"></label>
      <div class="control">
        <input type="text" :class="{'input': true, 'is-danger': errors.has(edc_bank_row.id)}" v-model="edc_bank_list[index_edc_bank].number" @keyup="searchEDC(edc_bank_row, index_edc_bank)">
      </div>
      <div class="control">
        <table class="table is-fullwidth">
          <tr v-for="(edc_row, index_edc) in edc_bank_list[index_edc_bank].edc_list" :key="index_edc">
            <td v-text="edc_row.title"></td>
            <td>
              <button v-if="edc_bank_list[index_edc_bank].edc_list[index_edc].id !== edc_bank_list[index_edc_bank].selected_edc" type="button" class="button is-link" @click="selectEDC(edc_row, index_edc_bank)">Select</button>
              <button v-else type="button" class="button is-warning">Selected</button>
            </td>
          </tr>
        </table>
      </div>
      <span class="help is-danger" v-show="errors.has(edc_bank_row.id)" v-text="errors.first(edc_bank_row.id)"></span>
    </div>
    <div class="field is-grouped">
      <div class="control">
        <button type="submit" class="button is-link">Select EDC</button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  data () {
    return {
      services_list: [],
      counter_list: [],
      edc_bank_list: [],
      selected_service: '',
      selected_counter: ''
    }
  },
  created () {
    this.getServicesList()
    this.getCounterList()
    this.getEDCBankList()

    var self = this
    self.$geb.emit({id: 'preloader', eventData: true})
    self.flyGetSession('edc')
    .then(function (response) {
      self.$geb.emit({id: 'preloader', eventData: false})
      if (response.data.response_code === 1) {
        self.list_bca_edc = response.data.data
        self.list_maybank_edc = response.data.data
      } else {
        var result = response.data.message
        for (var name in response.data.message) {
          self.errors.add(name, result[name])
        }
      }
    })
    .catch(function (response) {
      self.$geb.emit({id: 'preloader', eventData: false})
      self.errorMessage(response)
    })
  },
  methods: {
    selectEDC (edcRow, index) {
      this.edc_bank_list[index].selected_edc = edcRow.id
      // this.edc_bank_list[index_edc_bank].edc_list.title
    },
    searchEDC (edcBankRow, index) {
      var self = this
      self.flyPostSession('frontdesk/search_edc', {
        edc_bank_id: edcBankRow.id,
        search: this.edc_bank_list[index].number
      })
      .then(function (response) {
        if (response.data.response_code === 1) {
          self.edc_bank_list[index].edc_list = response.data.data
        } else {
          /*
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
          */
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    getEDCBankList () {
      var self = this
      self.flyGetSession('frontdesk/get_edc_bank')
      .then(function (response) {
        if (response.data.response_code === 1) {
          self.edc_bank_list = response.data.data

          var flagRedirect = 0
          if (self.getSessionItem('selected_counter') !== null && self.getSessionItem('selected_service') !== null) {
            for (var index in self.edc_bank_list) {
              if (self.getSessionItem('edc_bank_' + self.edc_bank_list[index].id) !== null) {
                flagRedirect = 1
              }
            }
          }

          if (flagRedirect === 1) {
            self.$router.push('/panel/frontdesk/dashboard')
          }
        } else {
          /*
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
          */
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    getServicesList () {
      var self = this
      self.flyGetSession('frontdesk/get_service')
      .then(function (response) {
        if (response.data.response_code === 1) {
          self.services_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    getCounterList () {
      var self = this
      self.flyGetSession('frontdesk/get_counter')
      .then(function (response) {
        if (response.data.response_code === 1) {
          self.counter_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    submitData () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('frontdesk/set_up_counter', {
        selected_service: this.selected_service,
        selected_counter: this.selected_counter,
        edc_bank: this.edc_bank_list
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.setSessionItem('selected_service', self.selected_service)
          self.setSessionItem('selected_counter', self.selected_counter)

          var edcData = response.data.data

          for (var index in edcData) {
            self.setSessionItem('edc_bank_' + edcData[index].id, edcData[index].edc_id)
            self.setSessionItem('edc_bank_number_' + edcData[index].id, edcData[index].number)
          }

          self.$router.push('/panel/frontdesk/dashboard')
        } else {
          self.$geb.emit({id: 'alert_modal', title: 'Service Task belum tersedia!', content: 'Silahkan hubungi Team Leader anda.', button_text: 'OK'})
          /*
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
          */
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/panel/frontdesk/Edc.vue